var site = site || {};
var generic = generic || {};
var POWERREVIEWS = POWERREVIEWS || {};

// Global vars used by power review engine.
var pr_loyaltymember2 = '0';
var pr_elistmember2 = '';

(function ($) {
  Drupal.behaviors.writeReview = {
    renderForm: function (args) {
      var context = args.context;
      var user = args.user;
      var prLocale = '';
      var prMerchantId = '';
      var locales = '';

      if (POWERREVIEWS && Drupal.settings.power_reviews && generic?.env?.query && context) {
        var $writeReviewContainer = $('#power-review-container', context);
        var $productImageContainer = $('.js-product-image', $writeReviewContainer);
        var productId = 'PROD' + this.sanitizePageID(generic.env.query('pr_page_id'));
        var params = [
          {
            products: [productId],
            category_fields: ['products'],
            product_fields: ['PROD_RGN_NAME', 'SHORT_DESC', 'SUB_LINE', 'skus', 'url'],
            sku_fields: ['LARGE_IMAGE']
          }
        ];

        generic.jsonrpc.fetch({
          method: 'prodcat',
          params: params,
          onSuccess: function (t) {
            var productDetails = t.getValue();

            if (typeof productDetails !== 'undefined') {
              var productName =
                typeof Drupal.settings.power_reviews.show_translation_title !== 'undefined'
                  ? productDetails.products[0].SUB_LINE
                  : productDetails.products[0].PROD_RGN_NAME;
              var productImageSrc = productDetails.products[0].skus[0].LARGE_IMAGE[0];
              var productImageUrl = productDetails.products[0].url;
              var productSubLine = productDetails.products[0].SHORT_DESC;

              $productImageContainer.attr('src', productImageSrc).attr('alt', productName);
              $('.js-product-image-link', $writeReviewContainer).attr('href', productImageUrl);
              $('.js-pr-product-name', $writeReviewContainer).html(productName);
              if (Drupal.settings.power_reviews.show_sub_line) {
                $('.js-pr-sub-line', $writeReviewContainer).html(productSubLine);
              }
            }
          }
        });

        var pageId = this.sanitizePageID(generic.env.query('pr_page_id'));

        // EL CA FR Config Changes.
        prLocale =
          document.location.hostname.search('francais.esteelauder.ca') !== -1
            ? Drupal.settings.power_reviews.locale_fr
            : Drupal.settings.power_reviews.locale;
        prMerchantId =
          document.location.hostname.search('francais.esteelauder.ca') !== -1
            ? Drupal.settings.power_reviews.merchant_id_fr
            : Drupal.settings.power_reviews.merchant_id;
        locales = $.cookie('LOCALE');

        if (locales && locales !== '') {
          locales = locales.toLowerCase();
          if (
            typeof Drupal.settings.power_reviews[locales] !== 'undefined' &&
            typeof Drupal.settings.power_reviews[locales]['merchant_id'] !== 'undefined' &&
            typeof Drupal.settings.power_reviews[locales]['locale'] !== 'undefined'
          ) {
            prMerchantId = Drupal.settings.power_reviews[locales]['merchant_id'];
            prLocale = Drupal.settings.power_reviews[locales]['locale'];
          }
        }
        var prArgs = {
          api_key: Drupal.settings.power_reviews.api_key,
          locale: prLocale,
          merchant_group_id: Drupal.settings.power_reviews.merchant_group_id,
          merchant_id: prMerchantId,
          page_id: pageId,
          components: {
            Write: 'pr-write'
          }
        };
        var $loyaltyReviewContainer = $('.js-write-review-container', context);

        if (typeof user !== 'undefined' && typeof user.user_id !== 'undefined') {
          prArgs.merchant_user_id = user.user_id;
        }
        if (typeof user !== 'undefined' && typeof user.email_address !== 'undefined') {
          prArgs.merchant_user_email = user.email_address;
        }
        if (user?.is_loyalty_member || user?.isLoyaltyMember) {
          pr_loyaltymember2 = '1';
          pr_elistmember2 = $('.js-elist-member', $loyaltyReviewContainer).text();
        }

        prArgs.on_submit = function () {
          $(window).scrollTop(0);
          $('.js-war-heading', $writeReviewContainer).addClass('hidden');
          if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
            site.track.reviewWriteEnd();
          }
        };

        prArgs.on_render = function () {
          var isLoyaltyMember = user.is_loyalty_member;
          var $loyalityButtonContainer = $('#pr-smartrewards .pr-btn-default');
          var $reviewContainer = $('.js-write-review-container', context);
          var $emailField = document.getElementById('pr-email_collection-input');
          var emailValue = $emailField.value;
          var inputEvent = new Event('input', { bubbles: true });
          // eslint-disable-next-line no-underscore-dangle
          var tracker = $emailField._valueTracker;

          if (typeof user !== 'undefined' && typeof user.email_address !== 'undefined' && tracker) {
            $emailField.value = user.email_address;
            tracker.setValue(emailValue);
            $emailField.dispatchEvent(inputEvent);
          }

          $reviewContainer
            .find('.pr-rating-stars [role=radio]')
            .attr('data-test-id', 'overall_rating_star_select');
          $reviewContainer
            .find('.pr-bottomline-form-group [role=radio]')
            .attr('data-test-id', 'review_recommend_product_select');
          $reviewContainer
            .find('.pr-name-form-group .pr-textinput')
            .attr('data-test-id', 'reviewer_name');
          $reviewContainer
            .find('.pr-location-form-group .pr-textinput')
            .attr('data-test-id', 'reviewer_location');
          $reviewContainer
            .find('.pr-age-form-group .form-control')
            .attr('data-test-id', 'reviewer_age');
          $reviewContainer
            .find('.pr-headline-form-group .pr-textinput')
            .attr('data-test-id', 'review_title');
          $reviewContainer
            .find('.pr-comments-form-group .pr-textarea')
            .attr('data-test-id', 'review_text');
          $reviewContainer
            .find('.pr-cb-tag-container')
            .attr('data-test-id', 'product_benefit_select');
          $reviewContainer
            .find('.pr-skinconcerns-form-group .pr-btn-add-tag')
            .attr('data-test-id', 'add_your_benefit');
          $reviewContainer.find('.pr-submit .pr-btn-review').attr('data-test-id', 'review_submit');
          if (isLoyaltyMember) {
            $loyalityButtonContainer.addClass('active').attr('aria-checked', true);
            $('.pr-btn-default:first', $('.pr-loyaltymember-form-group'))
              .addClass('active')
              .attr('aria-checked', true);
          } else {
            $('.pr-btn-default:last', $('.pr-loyaltymember-form-group'))
              .addClass('active')
              .attr('aria-checked', true);
          }
        };
        POWERREVIEWS.display?.render(prArgs);
      }
    },
    triggerSignin: function (args) {
      var context = args.context;
      var signinRequest = args.signinRequest;
      var that = this;
      var promo;
      var pwrEmailPromotions;
      var paramObj = {};

      if (signinRequest) {
        var inputVals = $('#power-review-container', context)
          .find('#js-signin-form')
          .serializeArray();

        // Loop through all the fields and get the values
        $.each(inputVals, function (index, formObj) {
          this.ignore = index;
          paramObj[formObj.name] = formObj.value;
        });
      } else {
        var email = $('.pr-email', context).val();

        pwrEmailPromotions = Drupal.settings.PWR_PC_EMAIL_PROMOTIONS || false;

        if (pwrEmailPromotions) {
          promo = $('.pwr-signin-form input[name="PC_EMAIL_PROMOTIONS"]:checked', context).length;
        } else {
          promo = $('input[name="PC_EMAIL_PROMOTIONS"]:checked', context).length;
        }
        var acceptedPrivacy = $('input[name="ACCEPTED_PRIVACY_POLICY"]:checked', context).length;

        paramObj.NEW_USER_EMAIL_ADDRESS = email;
        paramObj.PC_EMAIL_PROMOTIONS = promo;
        paramObj.ACCEPTED_PRIVACY_POLICY = acceptedPrivacy;
        paramObj._SUBMIT = 'signin_new_user';
      }
      generic.jsonrpc.fetch({
        method: 'rpc.form',
        params: [paramObj],
        onSuccess: function (r) {
          var userInfo = r.getData().userinfo;

          $('.js-signin-err-msg', context).empty().addClass('hidden');
          $('#pwr-signin', context).addClass('hidden');
          that.renderForm({
            context: context,
            user: userInfo
          });
        },
        onFailure: function (r) {
          var messages = r.getMessages();

          $('.js-signin-err-msg', context).empty().html(messages[0].text).removeClass('hidden');
        }
      });
    },
    isValidEmailAddress: function (emailAddress) {
      var atpos = emailAddress.indexOf('@');
      var dotpos = emailAddress.lastIndexOf('.');

      return atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailAddress.length ? false : true;
    },
    sanitizePageID: function (prPageId) {
      return prPageId.indexOf('PROD') >= 0 ? prPageId.substr(4) : prPageId;
    },
    renderProductInfo: function () {
      var $signinImageContainer = $('#pwr-signin .js-product-image');

      if ($signinImageContainer.length) {
        var productId = 'PROD' + generic.env.query('pr_page_id');
        var params = [
          {
            products: [productId],
            category_fields: ['products'],
            product_fields: ['PROD_RGN_NAME', 'IMAGE_SPP']
          }
        ];

        generic.jsonrpc.fetch({
          method: 'prodcat',
          params: params,
          onSuccess: function (t) {
            var productDetails = t.getValue();

            if (typeof productDetails.products[0] !== 'undefined') {
              var productImageSrc =
                typeof productDetails.products[0].IMAGE_SPP === 'object'
                  ? productDetails.products[0].IMAGE_SPP[0]
                  : productDetails.products[0].IMAGE_SPP;
              var productName = productDetails.products[0].PROD_RGN_NAME;

              $signinImageContainer
                .attr('src', productImageSrc)
                .attr('alt', productName)
                .attr('title', productName);
            }
          }
        });
      }
    },
    regEx: function (key) {
      if (!key) {
        return null;
      }

      return new RegExp('(?:^|&)' + key + ':([^;&,}]*)');
    },
    isLoggedIn: function () {
      var userCookie = generic.cookie('FE_USER_CART');

      if (!userCookie) {
        return false;
      }
      var signedIn = userCookie.match(this.regEx('signed_in'));

      return signedIn ? (signedIn[1] ? parseInt(signedIn[1]) === 1 : false) : false;
    },
    enableSubmit: function (context) {
      var $submitButton = $('.js-enable-submit', context);

      $submitButton.removeClass('disabled');

      if (
        $('.js-enable-tickbox', context).length === $('.js-enable-tickbox:checked', context).length
      ) {
        $submitButton.prop('disabled', false);
      } else {
        $submitButton.prop('disabled', true);
        $submitButton.addClass('disabled');
      }
    },
    attach: function (context) {
      var that = this;
      var signedIn = this.isLoggedIn();
      var appName = generic.env.query('appName');

      if (appName) {
        document.title =
          site.translations.product.product_pr_ask_answer + ' | ' + Drupal.settings.site_name;
      }
      if (signedIn) {
        $(document).on('user.loaded', function (e, user) {
          this.ignore = e;
          that.renderForm({
            context: context,
            user: user
          });
        });
      } else if (Drupal.settings.power_reviews.signin_required) {
        var pageId = that.sanitizePageID(generic.env.query('pr_page_id'));

        $('#customer-service', context).removeClass('hidden');
        // login flow method
        if (Drupal.settings.power_reviews.partial_signin) {
          var $enableSubmit = $('.js-enable-tickbox', context);
          var prValidEmail = $('#pr-valid-email', context).html();

          if ($enableSubmit.length > 0) {
            that.enableSubmit(context);
            $enableSubmit.once().on('click', function () {
              that.enableSubmit(context);
            });
          }

          $('#pwr-signin', context).removeClass('hidden');
          that.renderProductInfo();
          // Check whether registered user
          $('.email-check .btn-pr').on('click', function (evt) {
            evt.preventDefault();
            var email = $('.pr-email').val();

            if (that.isValidEmailAddress(email)) {
              generic.jsonrpc.fetch({
                method: 'user.registered',
                params: [{ email_address: email }],
                onSuccess: function (r) {
                  $('.js-signin-err-msg', context).empty().addClass('hidden');
                  var val = r.getValue();
                  var isUser = val !== null && val === 1;

                  if (isUser) {
                    // show full login
                    $('#pwr-signin .email-check').addClass('hidden');
                    $('#pwr-signin .full-sign-in').removeClass('hidden');
                    $('#pwr-signin input[name="EMAIL_ADDRESS"]').val(email);
                  } else {
                    // anonymous write-a-review
                    that.triggerSignin({
                      context: context,
                      signinRequest: 0
                    });
                  }
                },
                onFailure: function () {}
              });
            } else {
              $('.js-signin-err-msg', context).empty().html(prValidEmail).removeClass('hidden');
            }
          });
          $('.full-sign-in .btn-pr').on('click', function (evt) {
            evt.preventDefault();
            var email = $('#js-signin-form input[name="EMAIL_ADDRESS"]').val();

            if (that.isValidEmailAddress(email)) {
              $('.js-signin-err-msg', context).empty().addClass('hidden');
              that.triggerSignin({
                context: context,
                signinRequest: 1
              });
            } else {
              $('.js-signin-err-msg', context).empty().html(prValidEmail).removeClass('hidden');
            }
          });
          $(document).on('prodcat.status', that.renderProductInfo);
        } else {
          var returnUrl = encodeURIComponent(document.location.pathname + '?pr_page_id=' + pageId);

          if (appName) {
            returnUrl = encodeURIComponent(
              document.location.pathname + '?pr_page_id=' + pageId + '&appName=' + appName
            );
          }
          var signinUrl = '/account/signin.tmpl?RETURN_URL=' + returnUrl;

          document.location.href = signinUrl;
        }
      } else {
        that.renderForm({ context: context });
      }
    }
  };
})(jQuery);
